export default "__VITE_ASSET__DcHRFgui__"